import { ImageLocations, uploadFile } from './helpers/upload-file';

export const uploadImage = uploadFile;
export { ImageLocations };
